import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const NEWSLETTER_API_URL =
  (process.env.REACT_APP_API_DOMAIN || '') + '/ContactPHP/contact.php';

export const subscribeNewsletter = createAsyncThunk(
  'newsletter/subscribe',
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(NEWSLETTER_API_URL, {
        email,
        source: 'newsletter',
      });

      if (response.data && response.data.status === 'error') {
        return rejectWithValue(response.data.message || 'Verification failed');
      }
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      return rejectWithValue(msg);
    }
  }
);

const newsletterSlice = createSlice({
  name: 'newsletter',
  initialState: {
    status: 'idle',   // 'idle' | 'loading' | 'success' | 'error'
    message: '',
  },
  reducers: {
    resetNewsletter: (state) => {
      state.status = 'idle';
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeNewsletter.pending, (state) => {
        state.status = 'loading';
        state.message = '';
      })
      .addCase(subscribeNewsletter.fulfilled, (state) => {
        state.status = 'success';
        state.message = 'Thank you for subscribing!';
      })
      .addCase(subscribeNewsletter.rejected, (state, action) => {
        state.status = 'error';
        state.message = action.payload || 'Something went wrong.';
      });
  },
});

export const { resetNewsletter } = newsletterSlice.actions;
export default newsletterSlice.reducer;
